import { List } from "@chakra-ui/core";
import React from "react";

const FeatureList = (props) => {
  return <List mb={4} fontSize="sm" spacing={4} {...props}></List>;
};

export default FeatureList;
